var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResumefolderAmico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-18",
    d: "M91.43,411.5c87.58,43.87,229.56,43.87,317.14,0s87.57-115,0-158.87-229.56-43.87-317.14,0S3.86,367.63,91.43,411.5Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cabinet--inject-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--cabinet--inject-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "401.86 261.19 366.73 240.91 366.73 165.58 401.86 185.87 401.86 261.19",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.86 185.87 452.04 156.89 452.04 232.22 401.86 261.19 401.86 185.87",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.04 156.89 401.86 185.87 366.73 165.58 416.91 136.61 452.04 156.89",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.87 188.76 447.02 165.58 447.94 166.12 447.94 194.02 407.8 217.2 406.87 216.66 406.87 188.76",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.53,184.94l6.83-3.94c.89-.51,1.6-.28,1.6.52a3.19,3.19,0,0,1-1.6,2.37l-6.83,4c-.88.51-1.6.27-1.6-.53A3.21,3.21,0,0,1,423.53,184.94Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.95 224.07 446.1 200.89 446.09 228.79 447.02 229.32 406.87 252.5 405.95 251.97 405.95 224.07",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.87 224.6 447.02 201.42 447.02 229.32 406.87 252.5 406.87 224.6",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.61,220.24l6.83-3.94c.88-.51,1.6-.28,1.6.52a3.23,3.23,0,0,1-1.6,2.38l-6.83,3.94c-.89.51-1.61.28-1.61-.52A3.23,3.23,0,0,1,422.61,220.24Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.87 188.76 447.02 165.58 447.02 193.49 406.87 216.66 406.87 188.76",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "467.09 179.37 445.12 166.68 445.12 191.26 467.09 203.95 467.09 179.37",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.93 220.63 421.93 185.86 430.54 180.87 431.96 182.97 457.06 168.48 457.06 200.35 421.93 220.63",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.93 220.63 424.44 190.21 459.56 169.93 457.06 200.35 421.93 220.63",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.95 202.55 407.79 191.49 407.79 216.07 426.94 227.13 426.95 202.55",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.95 200.35 467.09 177.17 467.09 205.07 426.94 228.25 426.95 200.35",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.68,196l6.83-3.94c.88-.51,1.6-.28,1.6.52a3.23,3.23,0,0,1-1.6,2.38l-6.83,3.94c-.89.51-1.6.28-1.6-.52A3.23,3.23,0,0,1,442.68,196Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.95 200.35 425.61 199.58 425.61 227.48 426.95 228.25 426.95 200.35",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.61 199.58 465.75 176.4 467.09 177.17 426.95 200.35 425.61 199.58",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.63,267.25c.24-5.77,4.79-17.94,11.08-25.2s16.17-11.83,22.78-9.27c6.14,2.39,5.14,10.54-2.64,15.65s-19.43,11.47-23.13,20.7l-7.44,11.22Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.63,267.25c.24-5.77,4.79-17.94,11.08-25.2s16.17-11.83,22.78-9.27c6.14,2.39,5.14,10.54-2.64,15.65s-19.43,11.47-23.13,20.7l-7.44,11.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.05,235.6c-7.48,1.74-29,16.83-31,38.42",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.02594px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.53,290.18c.35-6,5.46-10.32,12.19-14.27,8-4.68,14.9-6.79,17.33-11.4s-1.92-9.82-10.17-7.07c-7,2.33-20.51,14.32-20.6,22.91Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.83,261.1c-11.05,2.53-23.4,12.58-25.06,23.11",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folder--inject-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--folder--inject-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "71.54 199.13 71.54 372.92 249.41 270.22 249.41 112.23 117.15 188.59 112.58 175.43 71.54 199.13",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.54 372.92 80.66 214.92 258.53 112.23 249.41 270.22 71.54 372.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.54 372.92 85.22 217.56 263.09 114.86 249.41 270.22 71.54 372.92",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Resumes--inject-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--folder--inject-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "119.06 232.89 119.06 406.68 296.94 303.98 296.94 145.99 164.67 222.35 160.11 209.19 119.06 232.89",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "119.06 232.89 119.06 406.68 296.94 303.98 296.94 145.99 164.67 222.35 160.11 209.19 119.06 232.89"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Document--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.66,346a4.2,4.2,0,0,1-1.85-3.33V125.84a4.32,4.32,0,0,1,2-3.4L319.93,43.83a3.69,3.69,0,0,1,5.65,3.26V263.9a4.34,4.34,0,0,1-2,3.4L187.47,345.9A4.2,4.2,0,0,1,183.66,346Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5,130l55.29-36.18-3.68-2.12-53.33,30.79a4.32,4.32,0,0,0-2,3.4v2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.93,136.34,182.39,123.9a4,4,0,0,0-.58,1.94v216.8a3.69,3.69,0,0,0,5.65,3.26l16.47-9.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.47,345.9l136.14-78.6a4.34,4.34,0,0,0,2-3.4V47.09c0-1.25-.88-1.76-2-1.13l-136.15,78.6a4.36,4.36,0,0,0-2,3.41v216.8C185.5,346,186.38,346.53,187.47,345.9Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.8,178l32.69-18.87c2.17-1.25,3.93-.36,3.93,2a8.41,8.41,0,0,1-3.93,6.52L196.8,186.56c-2.17,1.25-3.93.36-3.93-2A8.45,8.45,0,0,1,196.8,178Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.44,212.55l4.23-2.44c.87-.5,1.57-.1,1.57.9v4.89a3.46,3.46,0,0,1-1.57,2.72l-4.23,2.44c-.86.5-1.57.1-1.57-.91v-4.88A3.49,3.49,0,0,1,194.44,212.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.9,208.07l25.56-14.76c1.08-.63,2-.18,2,1a4.2,4.2,0,0,1-2,3.26L205.9,212.32c-1.09.63-2,.18-2-1A4.18,4.18,0,0,1,205.9,208.07Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.44,229.58l4.23-2.45c.87-.5,1.57-.09,1.57.91v4.89a3.46,3.46,0,0,1-1.57,2.72l-4.23,2.44c-.86.5-1.57.09-1.57-.91V232.3A3.49,3.49,0,0,1,194.44,229.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.9,225.09l25.56-14.75c1.08-.63,2-.19,2,1a4.22,4.22,0,0,1-2,3.26L205.9,229.35c-1.09.63-2,.18-2-1A4.22,4.22,0,0,1,205.9,225.09Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.44,246.6l4.23-2.44c.87-.5,1.57-.1,1.57.91V250a3.46,3.46,0,0,1-1.57,2.72l-4.23,2.44c-.86.51-1.57.1-1.57-.9v-4.89A3.49,3.49,0,0,1,194.44,246.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.9,242.12l25.56-14.76c1.08-.63,2-.18,2,1a4.23,4.23,0,0,1-2,3.27L205.9,246.37c-1.09.63-2,.19-2-1A4.18,4.18,0,0,1,205.9,242.12Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.44,263.67l4.23-2.44c.87-.5,1.57-.09,1.57.91V267a3.46,3.46,0,0,1-1.57,2.72l-4.23,2.44c-.86.51-1.57.1-1.57-.9v-4.89A3.49,3.49,0,0,1,194.44,263.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.9,259.19l25.56-14.76c1.08-.63,2-.18,2,1a4.23,4.23,0,0,1-2,3.27L205.9,263.44c-1.09.63-2,.19-2-1A4.2,4.2,0,0,1,205.9,259.19Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.84,299.27,213,288.77c1.08-.63,2-.18,2,1a4.2,4.2,0,0,1-2,3.26l-18.19,10.51c-1.09.62-2,.18-2-1A4.22,4.22,0,0,1,194.84,299.27Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.84,307.78l36.62-21.14c1.08-.63,2-.18,2,1a4.23,4.23,0,0,1-2,3.27L194.84,312c-1.09.63-2,.18-2-1A4.22,4.22,0,0,1,194.84,307.78Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.84,307.78,220.4,293c1.08-.62,2-.18,2,1a4.22,4.22,0,0,1-2,3.26L194.84,312c-1.09.63-2,.18-2-1A4.22,4.22,0,0,1,194.84,307.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.84,316.29,213,305.78c1.08-.62,2-.18,2,1a4.23,4.23,0,0,1-2,3.26l-18.19,10.5c-1.09.63-2,.18-2-1A4.18,4.18,0,0,1,194.84,316.29Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.84,282.25,213,271.75c1.08-.62,2-.18,2,1a4.23,4.23,0,0,1-2,3.26l-18.19,10.5c-1.09.63-2,.18-2-1A4.22,4.22,0,0,1,194.84,282.25Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.84,290.77l36.62-21.15c1.08-.62,2-.18,2,1a4.23,4.23,0,0,1-2,3.26L194.84,295c-1.09.63-2,.18-2-1A4.18,4.18,0,0,1,194.84,290.77Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.84,290.77l13-7.5c1.09-.63,2-.18,2,1a4.22,4.22,0,0,1-2,3.27l-13,7.49c-1.09.63-2,.18-2-1A4.18,4.18,0,0,1,194.84,290.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.84,324.8l36.62-21.14c1.08-.63,2-.18,2,1a4.2,4.2,0,0,1-2,3.26l-36.62,21.15c-1.09.62-2,.18-2-1A4.22,4.22,0,0,1,194.84,324.8Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.84,324.8l32.93-19c1.09-.62,2-.18,2,1a4.25,4.25,0,0,1-2,3.26l-32.93,19c-1.09.62-2,.18-2-1A4.22,4.22,0,0,1,194.84,324.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.61,46,240.79,93.77V315.11l82.82-47.81a4.34,4.34,0,0,0,2-3.4V47.09C325.58,45.84,324.7,45.33,323.61,46Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.79 102.29 240.79 119.31 233.42 127.83 240.79 127.83 240.79 144.85 318.2 100.16 318.2 57.59 240.79 102.29",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.92,102.88l31.36-18.11c1.52-.87,2.75-.16,2.75,1.59v0a6.08,6.08,0,0,1-2.75,4.77l-31.36,18.1c-1.52.88-2.75.17-2.75-1.58v0A6.08,6.08,0,0,1,250.92,102.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.15,116.62l60.7-35.05c.54-.31,1-.09,1,.5a2.1,2.1,0,0,1-1,1.63l-60.7,35.05c-.54.31-1,.09-1-.5A2.1,2.1,0,0,1,249.15,116.62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.15,123l60.7-35c.54-.32,1-.09,1,.49a2.13,2.13,0,0,1-1,1.64l-60.7,35c-.54.31-1,.09-1-.5A2.13,2.13,0,0,1,249.15,123Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.15,129.39l60.7-35c.54-.31,1-.09,1,.5a2.1,2.1,0,0,1-1,1.63l-60.7,35.05c-.54.31-1,.09-1-.5A2.1,2.1,0,0,1,249.15,129.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.43,147.24l4.23-2.44c.87-.5,1.58-.1,1.58.91v4.88a3.48,3.48,0,0,1-1.58,2.72l-4.23,2.44c-.86.5-1.57.1-1.57-.9V150A3.49,3.49,0,0,1,251.43,147.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.89,142.76,288.45,128c1.08-.63,2-.18,2,1a4.23,4.23,0,0,1-2,3.27L262.89,147c-1.09.63-2,.19-2-1A4.18,4.18,0,0,1,262.89,142.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.85,162.49l64.38-37.18c.55-.32,1-.09,1,.49a2.08,2.08,0,0,1-1,1.63l-64.38,37.19c-.55.31-1,.09-1-.5A2.08,2.08,0,0,1,250.85,162.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.85,168.87l64.38-37.18c.55-.31,1-.09,1,.5a2.08,2.08,0,0,1-1,1.63L250.85,171c-.55.31-1,.09-1-.5A2.12,2.12,0,0,1,250.85,168.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.85,175.26l64.38-37.18c.55-.32,1-.1,1,.49a2.08,2.08,0,0,1-1,1.63l-64.38,37.18c-.55.32-1,.1-1-.49A2.08,2.08,0,0,1,250.85,175.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.85,181.66l64.38-37.18c.55-.32,1-.09,1,.5a2.12,2.12,0,0,1-1,1.63l-64.38,37.18c-.55.31-1,.09-1-.5A2.08,2.08,0,0,1,250.85,181.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.43,194.06l4.23-2.44c.87-.5,1.58-.09,1.58.91v4.88a3.48,3.48,0,0,1-1.58,2.72l-4.23,2.45c-.86.5-1.57.09-1.57-.91v-4.88A3.49,3.49,0,0,1,251.43,194.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.89,189.58l25.56-14.76c1.08-.62,2-.18,2,1a4.23,4.23,0,0,1-2,3.26l-25.56,14.76c-1.09.62-2,.18-2-1A4.22,4.22,0,0,1,262.89,189.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.85,209.31l64.38-37.18c.55-.31,1-.09,1,.5a2.12,2.12,0,0,1-1,1.63l-64.38,37.18c-.55.31-1,.09-1-.5A2.08,2.08,0,0,1,250.85,209.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.85,215.69l64.38-37.18c.55-.31,1-.09,1,.5a2.08,2.08,0,0,1-1,1.63l-64.38,37.18c-.55.32-1,.09-1-.49A2.12,2.12,0,0,1,250.85,215.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.85,222.08l64.38-37.18c.55-.32,1-.09,1,.49a2.12,2.12,0,0,1-1,1.64l-64.38,37.18c-.55.31-1,.09-1-.5A2.08,2.08,0,0,1,250.85,222.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.85,228.48l64.38-37.18c.55-.31,1-.09,1,.5a2.08,2.08,0,0,1-1,1.63l-64.38,37.18c-.55.31-1,.09-1-.5A2.12,2.12,0,0,1,250.85,228.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.46,237.82l4.22-2.44c.87-.51,1.58-.1,1.58.9v4.89a3.48,3.48,0,0,1-1.58,2.72l-4.22,2.44c-.87.5-1.58.1-1.58-.91v-4.88A3.48,3.48,0,0,1,257.46,237.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.85,254.41l17.45-10.08c.54-.31,1-.09,1,.5a2.1,2.1,0,0,1-1,1.63l-17.45,10.07c-.55.32-1,.09-1-.49A2.08,2.08,0,0,1,250.85,254.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.93,224.26l4.22-2.44c.87-.51,1.58-.1,1.58.9v4.89a3.48,3.48,0,0,1-1.58,2.72l-4.22,2.44c-.87.5-1.58.09-1.58-.91V227A3.48,3.48,0,0,1,280.93,224.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.32,240.84l17.45-10.07c.54-.31,1-.09,1,.5a2.1,2.1,0,0,1-1,1.63L274.32,243c-.55.32-1,.09-1-.49A2.12,2.12,0,0,1,274.32,240.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.4,210.7l4.22-2.45c.87-.5,1.58-.09,1.58.91V214a3.48,3.48,0,0,1-1.58,2.73l-4.22,2.44c-.87.5-1.58.09-1.58-.91v-4.88A3.48,3.48,0,0,1,304.4,210.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.78,227.28l17.45-10.07c.55-.31,1-.09,1,.5a2.08,2.08,0,0,1-1,1.63l-17.45,10.07c-.54.32-1,.09-1-.5A2.13,2.13,0,0,1,297.78,227.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.85,258.56l17.45-10.07c.54-.31,1-.09,1,.5a2.13,2.13,0,0,1-1,1.63l-17.45,10.07c-.55.31-1,.09-1-.5A2.1,2.1,0,0,1,250.85,258.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.32,245l17.45-10.07c.54-.32,1-.09,1,.49a2.13,2.13,0,0,1-1,1.64l-17.45,10.07c-.55.31-1,.09-1-.5A2.08,2.08,0,0,1,274.32,245Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.78,231.44l17.45-10.07c.55-.32,1-.09,1,.49a2.12,2.12,0,0,1-1,1.64l-17.45,10.07c-.54.31-1,.09-1-.5A2.1,2.1,0,0,1,297.78,231.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.85,262.72l17.45-10.08c.54-.31,1-.09,1,.5a2.1,2.1,0,0,1-1,1.63l-17.45,10.08c-.55.31-1,.09-1-.5A2.08,2.08,0,0,1,250.85,262.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.32,249.16l17.45-10.08c.54-.31,1-.09,1,.5a2.1,2.1,0,0,1-1,1.63l-17.45,10.08c-.55.31-1,.09-1-.5A2.08,2.08,0,0,1,274.32,249.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.78,235.6l17.45-10.08c.55-.31,1-.09,1,.5a2.08,2.08,0,0,1-1,1.63l-17.45,10.07c-.54.32-1,.1-1-.49A2.1,2.1,0,0,1,297.78,235.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.46,272.77l4.22-2.44c.87-.5,1.58-.09,1.58.91v4.88a3.48,3.48,0,0,1-1.58,2.72l-4.22,2.44c-.87.51-1.58.1-1.58-.9v-4.89A3.48,3.48,0,0,1,257.46,272.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.85,289.36l17.45-10.07c.54-.32,1-.09,1,.49a2.1,2.1,0,0,1-1,1.63l-17.45,10.08c-.55.31-1,.09-1-.5A2.08,2.08,0,0,1,250.85,289.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.93,259.21l4.22-2.44c.87-.5,1.58-.1,1.58.91v4.88a3.48,3.48,0,0,1-1.58,2.72l-4.22,2.44c-.87.51-1.58.1-1.58-.9v-4.89A3.48,3.48,0,0,1,280.93,259.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.32,275.8l17.45-10.07c.54-.32,1-.1,1,.49a2.1,2.1,0,0,1-1,1.63l-17.45,10.08c-.55.31-1,.09-1-.5A2.08,2.08,0,0,1,274.32,275.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.4,245.65l4.22-2.44c.87-.5,1.58-.1,1.58.91V249a3.48,3.48,0,0,1-1.58,2.72l-4.22,2.44c-.87.5-1.58.1-1.58-.9v-4.89A3.48,3.48,0,0,1,304.4,245.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.78,262.24l17.45-10.08c.55-.31,1-.09,1,.5a2.08,2.08,0,0,1-1,1.63l-17.45,10.08c-.54.31-1,.09-1-.5A2.1,2.1,0,0,1,297.78,262.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.85,293.52l17.45-10.08c.54-.31,1-.09,1,.5a2.1,2.1,0,0,1-1,1.63l-17.45,10.07c-.55.32-1,.09-1-.49A2.08,2.08,0,0,1,250.85,293.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.32,280l17.45-10.07c.54-.31,1-.09,1,.5a2.1,2.1,0,0,1-1,1.63l-17.45,10.07c-.55.32-1,.09-1-.49A2.12,2.12,0,0,1,274.32,280Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.78,266.39l17.45-10.07c.55-.31,1-.09,1,.5a2.08,2.08,0,0,1-1,1.63l-17.45,10.07c-.54.32-1,.09-1-.49A2.13,2.13,0,0,1,297.78,266.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.85,297.67,268.3,287.6c.54-.31,1-.09,1,.5a2.13,2.13,0,0,1-1,1.63L250.85,299.8c-.55.31-1,.09-1-.5A2.12,2.12,0,0,1,250.85,297.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.32,284.11,291.77,274c.54-.31,1-.09,1,.5a2.13,2.13,0,0,1-1,1.63l-17.45,10.07c-.55.31-1,.09-1-.5A2.08,2.08,0,0,1,274.32,284.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.78,270.55l17.45-10.07c.55-.32,1-.09,1,.49a2.12,2.12,0,0,1-1,1.64l-17.45,10.07c-.54.31-1,.09-1-.5A2.1,2.1,0,0,1,297.78,270.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.3,119.37c10.21-5.89,18.48-1.12,18.48,10.67s-8.27,26.1-18.48,32-18.47,1.12-18.47-10.66S201.1,125.26,211.3,119.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.3,128.64c3.31-1.91,6-.36,6,3.46a13.25,13.25,0,0,1-6,10.38c-3.31,1.91-6,.36-6-3.46A13.24,13.24,0,0,1,211.3,128.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,149c0-6.28-4.41-8.82-9.85-5.68l-3.4,2c-5.44,3.14-9.85,10.78-9.85,17.06v1.69c3.15,1,7.1.47,11.41-2A36.43,36.43,0,0,0,223,150.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.37,192.38l25.56-14.76c1.08-.63,2-.18,2,1a4.2,4.2,0,0,1-2,3.26l-25.56,14.76c-1.09.63-2,.18-2-1A4.18,4.18,0,0,1,200.37,192.38Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "119.07 406.68 151.56 265.96 329.43 163.27 296.94 303.98 119.07 406.68",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.43 355.08 208.43 233.13 328.96 163.88 296.94 303.98 208.43 355.08",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--Shadow--inject-18",
    points: "239.08 372.79 208.43 355.08 265.51 322.37 239.08 372.79",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--document--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.08,372.79a4.21,4.21,0,0,1-1.84-3.33V152.65a4.36,4.36,0,0,1,2-3.4L375.35,70.64A3.69,3.69,0,0,1,381,73.91v216.8a4.34,4.34,0,0,1-2,3.4L242.89,372.72A4.23,4.23,0,0,1,239.08,372.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.92,156.77l55.3-36.18-3.69-2.13L239.2,149.25a4.36,4.36,0,0,0-2,3.4v2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.35,163.15l-21.54-12.43a4,4,0,0,0-.57,1.93V369.46a3.69,3.69,0,0,0,5.65,3.26l16.46-9.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.89,372.72,379,294.11a4.34,4.34,0,0,0,2-3.4V73.91c0-1.26-.88-1.76-2-1.14L242.89,151.38a4.32,4.32,0,0,0-2,3.4v216.8C240.92,372.84,241.8,373.34,242.89,372.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.22,204.86,284.91,186c2.17-1.25,3.93-.36,3.93,2a8.45,8.45,0,0,1-3.93,6.53l-32.69,18.87c-2.17,1.25-3.93.36-3.93-2A8.41,8.41,0,0,1,252.22,204.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.87,239.36l4.23-2.44c.86-.5,1.57-.09,1.57.91v4.88a3.51,3.51,0,0,1-1.57,2.73l-4.23,2.44c-.87.5-1.57.09-1.57-.91v-4.88A3.47,3.47,0,0,1,249.87,239.36Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.32,234.88l25.56-14.76c1.08-.62,2-.18,2,1a4.23,4.23,0,0,1-2,3.26l-25.56,14.76c-1.09.62-2,.18-2-1A4.22,4.22,0,0,1,261.32,234.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.87,256.39,254.1,254c.86-.5,1.57-.1,1.57.91v4.88a3.49,3.49,0,0,1-1.57,2.72l-4.23,2.44c-.87.5-1.57.1-1.57-.9v-4.89A3.46,3.46,0,0,1,249.87,256.39Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.32,251.91l25.56-14.76c1.08-.63,2-.18,2,1a4.23,4.23,0,0,1-2,3.27l-25.56,14.75c-1.09.63-2,.19-2-1A4.18,4.18,0,0,1,261.32,251.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.87,273.42,254.1,271c.86-.5,1.57-.09,1.57.91v4.88a3.49,3.49,0,0,1-1.57,2.73l-4.23,2.44c-.87.5-1.57.09-1.57-.91v-4.88A3.46,3.46,0,0,1,249.87,273.42Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.32,268.93l25.56-14.76c1.08-.62,2-.18,2,1a4.22,4.22,0,0,1-2,3.26l-25.56,14.76c-1.09.63-2,.18-2-1A4.22,4.22,0,0,1,261.32,268.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.87,290.49,254.1,288c.86-.5,1.57-.09,1.57.91v4.89a3.49,3.49,0,0,1-1.57,2.72L249.87,299c-.87.5-1.57.09-1.57-.91v-4.88A3.46,3.46,0,0,1,249.87,290.49Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.32,286l25.56-14.75c1.08-.63,2-.19,2,1a4.22,4.22,0,0,1-2,3.26l-25.56,14.76c-1.09.63-2,.18-2-1A4.22,4.22,0,0,1,261.32,286Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26,326.08l18.19-10.5c1.08-.62,2-.18,2,1a4.23,4.23,0,0,1-2,3.26l-18.19,10.5c-1.08.63-2,.18-2-1A4.23,4.23,0,0,1,250.26,326.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26,334.6l36.62-21.15c1.08-.62,2-.18,2,1a4.23,4.23,0,0,1-2,3.26l-36.62,21.14c-1.08.63-2,.18-2-1A4.2,4.2,0,0,1,250.26,334.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26,334.6l25.56-14.76c1.09-.63,2-.18,2,1a4.22,4.22,0,0,1-2,3.27l-25.56,14.75c-1.08.63-2,.18-2-1A4.2,4.2,0,0,1,250.26,334.6Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26,343.1l18.19-10.5c1.08-.63,2-.18,2,1a4.23,4.23,0,0,1-2,3.27l-18.19,10.5c-1.08.62-2,.18-2-1A4.23,4.23,0,0,1,250.26,343.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26,309.07l18.19-10.5c1.08-.63,2-.18,2,1a4.2,4.2,0,0,1-2,3.26l-18.19,10.5c-1.08.63-2,.19-2-1A4.2,4.2,0,0,1,250.26,309.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26,317.58l36.62-21.14c1.08-.63,2-.18,2,1a4.2,4.2,0,0,1-2,3.26l-36.62,21.15c-1.08.62-2,.18-2-1A4.23,4.23,0,0,1,250.26,317.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26,317.58l13-7.5c1.08-.62,2-.18,2,1a4.23,4.23,0,0,1-2,3.26l-13,7.5c-1.08.62-2,.18-2-1A4.23,4.23,0,0,1,250.26,317.58Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26,351.61l36.62-21.14c1.08-.63,2-.18,2,1a4.23,4.23,0,0,1-2,3.26l-36.62,21.14c-1.08.63-2,.18-2-1A4.23,4.23,0,0,1,250.26,351.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.26,351.61l32.93-19c1.09-.63,2-.18,2,1a4.22,4.22,0,0,1-2,3.27l-32.93,19c-1.08.63-2,.18-2-1A4.23,4.23,0,0,1,250.26,351.61Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,72.77l-82.81,47.82V341.93L379,294.11a4.34,4.34,0,0,0,2-3.4V73.91C381,72.65,380.12,72.15,379,72.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.22 129.1 296.22 146.13 288.84 154.64 296.21 154.64 296.22 171.67 373.63 126.97 373.63 84.41 296.22 129.1",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.34,129.69l31.36-18.1c1.52-.88,2.75-.17,2.75,1.59v0A6.06,6.06,0,0,1,337.7,118l-31.36,18.11c-1.52.88-2.75.17-2.75-1.59v0A6.08,6.08,0,0,1,306.34,129.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.57,143.43l60.7-35c.55-.32,1-.09,1,.49a2.11,2.11,0,0,1-1,1.64l-60.7,35c-.54.31-1,.09-1-.5A2.13,2.13,0,0,1,304.57,143.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.57,149.82l60.7-35c.55-.31,1-.09,1,.5a2.07,2.07,0,0,1-1,1.63l-60.7,35c-.54.31-1,.09-1-.5A2.1,2.1,0,0,1,304.57,149.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.57,156.2l60.7-35c.55-.32,1-.09,1,.49a2.07,2.07,0,0,1-1,1.63l-60.7,35.05c-.54.31-1,.09-1-.5A2.13,2.13,0,0,1,304.57,156.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.86,174.06l4.23-2.45c.86-.5,1.57-.09,1.57.91v4.88a3.49,3.49,0,0,1-1.57,2.73l-4.23,2.44c-.87.5-1.57.09-1.57-.91v-4.88A3.46,3.46,0,0,1,306.86,174.06Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.31,169.57l25.56-14.76c1.09-.62,2-.18,2,1a4.2,4.2,0,0,1-2,3.26l-25.56,14.76c-1.09.62-2,.18-2-1A4.22,4.22,0,0,1,318.31,169.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.27,189.3l64.39-37.18c.54-.31,1-.09,1,.5a2.1,2.1,0,0,1-1,1.63l-64.39,37.18c-.54.31-1,.09-1-.5A2.13,2.13,0,0,1,306.27,189.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.27,195.69l64.39-37.18c.54-.32,1-.1,1,.49a2.1,2.1,0,0,1-1,1.63l-64.39,37.18c-.54.32-1,.1-1-.49A2.1,2.1,0,0,1,306.27,195.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.27,202.07l64.39-37.18c.54-.31,1-.09,1,.5a2.13,2.13,0,0,1-1,1.63L306.27,204.2c-.54.31-1,.09-1-.5A2.1,2.1,0,0,1,306.27,202.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.27,208.47l64.39-37.18c.54-.31,1-.09,1,.5a2.1,2.1,0,0,1-1,1.63L306.27,210.6c-.54.32-1,.09-1-.49A2.13,2.13,0,0,1,306.27,208.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.86,220.88l4.23-2.44c.86-.5,1.57-.1,1.57.9v4.89a3.49,3.49,0,0,1-1.57,2.72l-4.23,2.44c-.87.5-1.57.1-1.57-.91V223.6A3.46,3.46,0,0,1,306.86,220.88Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.31,216.39l25.56-14.75c1.09-.63,2-.18,2,1a4.17,4.17,0,0,1-2,3.26l-25.56,14.76c-1.09.63-2,.18-2-1A4.22,4.22,0,0,1,318.31,216.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.27,236.12l64.39-37.18c.54-.31,1-.09,1,.5a2.1,2.1,0,0,1-1,1.63l-64.39,37.18c-.54.32-1,.09-1-.49A2.13,2.13,0,0,1,306.27,236.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.27,242.51l64.39-37.18c.54-.32,1-.09,1,.49a2.13,2.13,0,0,1-1,1.64l-64.39,37.18c-.54.31-1,.09-1-.5A2.1,2.1,0,0,1,306.27,242.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.27,248.89l64.39-37.18c.54-.31,1-.09,1,.5a2.1,2.1,0,0,1-1,1.63L306.27,251c-.54.32-1,.09-1-.5A2.13,2.13,0,0,1,306.27,248.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.27,255.3l64.39-37.18c.54-.32,1-.1,1,.49a2.1,2.1,0,0,1-1,1.63l-64.39,37.18c-.54.32-1,.1-1-.49A2.1,2.1,0,0,1,306.27,255.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.88,264.63l4.23-2.44c.87-.5,1.57-.09,1.57.91V268a3.46,3.46,0,0,1-1.57,2.72l-4.23,2.45c-.87.5-1.57.09-1.57-.91v-4.89A3.46,3.46,0,0,1,312.88,264.63Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.27,281.22l17.45-10.07c.54-.32,1-.09,1,.49a2.1,2.1,0,0,1-1,1.63l-17.45,10.08c-.54.31-1,.09-1-.5A2.1,2.1,0,0,1,306.27,281.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.35,251.07l4.23-2.44c.87-.5,1.57-.1,1.57.91v4.88a3.46,3.46,0,0,1-1.57,2.72l-4.23,2.44c-.87.51-1.57.1-1.57-.9v-4.89A3.46,3.46,0,0,1,336.35,251.07Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.74,267.66l17.45-10.07c.54-.32,1-.09,1,.49a2.1,2.1,0,0,1-1,1.63l-17.45,10.08c-.54.31-1,.09-1-.5A2.1,2.1,0,0,1,329.74,267.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.82,237.51l4.23-2.44c.87-.5,1.57-.1,1.57.91v4.88a3.46,3.46,0,0,1-1.57,2.72L359.82,246c-.87.5-1.57.1-1.57-.9v-4.89A3.46,3.46,0,0,1,359.82,237.51Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.21,254.1,370.66,244c.54-.32,1-.1,1,.49a2.1,2.1,0,0,1-1,1.63l-17.45,10.08c-.54.31-1,.09-1-.5A2.1,2.1,0,0,1,353.21,254.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.27,285.38l17.45-10.08c.54-.31,1-.09,1,.5a2.1,2.1,0,0,1-1,1.63L306.27,287.5c-.54.32-1,.1-1-.49A2.1,2.1,0,0,1,306.27,285.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.74,271.82l17.45-10.08c.54-.31,1-.09,1,.5a2.1,2.1,0,0,1-1,1.63l-17.45,10.07c-.54.32-1,.09-1-.49A2.1,2.1,0,0,1,329.74,271.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.21,258.25l17.45-10.07c.54-.31,1-.09,1,.5a2.1,2.1,0,0,1-1,1.63l-17.45,10.07c-.54.32-1,.09-1-.49A2.13,2.13,0,0,1,353.21,258.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.27,289.53l17.45-10.07c.54-.31,1-.09,1,.5a2.13,2.13,0,0,1-1,1.63l-17.45,10.07c-.54.31-1,.09-1-.5A2.13,2.13,0,0,1,306.27,289.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.74,276l17.45-10.07c.54-.31,1-.09,1,.5a2.13,2.13,0,0,1-1,1.63L329.74,278.1c-.54.31-1,.09-1-.5A2.12,2.12,0,0,1,329.74,276Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.21,262.41l17.45-10.07c.54-.32,1-.09,1,.49a2.13,2.13,0,0,1-1,1.64l-17.45,10.07c-.54.31-1,.09-1-.5A2.1,2.1,0,0,1,353.21,262.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.88,299.59l4.23-2.45c.87-.5,1.57-.09,1.57.91v4.89a3.46,3.46,0,0,1-1.57,2.72l-4.23,2.44c-.87.5-1.57.09-1.57-.91v-4.88A3.46,3.46,0,0,1,312.88,299.59Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.27,316.17l17.45-10.07c.54-.31,1-.09,1,.5a2.1,2.1,0,0,1-1,1.63L306.27,318.3c-.54.32-1,.09-1-.49A2.13,2.13,0,0,1,306.27,316.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.35,286l4.23-2.45c.87-.5,1.57-.09,1.57.91v4.88a3.47,3.47,0,0,1-1.57,2.73l-4.23,2.44c-.87.5-1.57.09-1.57-.91v-4.88A3.46,3.46,0,0,1,336.35,286Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.74,302.61l17.45-10.07c.54-.31,1-.09,1,.5a2.12,2.12,0,0,1-1,1.63l-17.45,10.07c-.54.31-1,.09-1-.5A2.13,2.13,0,0,1,329.74,302.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.82,272.46l4.23-2.44c.87-.5,1.57-.09,1.57.91v4.88a3.48,3.48,0,0,1-1.57,2.73L359.82,281c-.87.5-1.57.09-1.57-.91v-4.88A3.48,3.48,0,0,1,359.82,272.46Z",
    style: {
      fill: "#263F8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.21,289.05,370.66,279c.54-.31,1-.09,1,.5a2.13,2.13,0,0,1-1,1.63l-17.45,10.07c-.54.31-1,.09-1-.5A2.13,2.13,0,0,1,353.21,289.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.27,320.33l17.45-10.07c.54-.32,1-.09,1,.49a2.13,2.13,0,0,1-1,1.64l-17.45,10.07c-.54.31-1,.09-1-.5A2.1,2.1,0,0,1,306.27,320.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.74,306.77l17.45-10.07c.54-.32,1-.09,1,.49a2.1,2.1,0,0,1-1,1.63L329.74,308.9c-.54.31-1,.09-1-.5A2.1,2.1,0,0,1,329.74,306.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.21,293.21l17.45-10.07c.54-.32,1-.09,1,.49a2.1,2.1,0,0,1-1,1.63l-17.45,10.08c-.54.31-1,.09-1-.5A2.1,2.1,0,0,1,353.21,293.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.27,324.49l17.45-10.08c.54-.31,1-.09,1,.5a2.1,2.1,0,0,1-1,1.63l-17.45,10.08c-.54.31-1,.09-1-.5A2.1,2.1,0,0,1,306.27,324.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.74,310.93l17.45-10.08c.54-.31,1-.09,1,.5a2.1,2.1,0,0,1-1,1.63l-17.45,10.07c-.54.32-1,.1-1-.49A2.1,2.1,0,0,1,329.74,310.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.21,297.37l17.45-10.08c.54-.31,1-.09,1,.5a2.1,2.1,0,0,1-1,1.63l-17.45,10.07c-.54.32-1,.09-1-.49A2.1,2.1,0,0,1,353.21,297.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.73,146.18c10.2-5.89,18.47-1.11,18.47,10.67s-8.27,26.11-18.47,32-18.48,1.11-18.48-10.67S256.52,152.07,266.73,146.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.73,155.46c3.31-1.92,6-.37,6,3.46a13.24,13.24,0,0,1-6,10.38c-3.31,1.91-6,.36-6-3.46A13.24,13.24,0,0,1,266.73,155.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.41,175.84c0-6.28-4.41-8.83-9.85-5.69l-3.4,2c-5.44,3.14-9.84,10.78-9.84,17.06v1.69c3.14,1,7.1.48,11.41-2a36.34,36.34,0,0,0,11.68-11.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.79,219.19l25.56-14.76c1.08-.62,2-.18,2,1a4.23,4.23,0,0,1-2,3.26l-25.56,14.76c-1.09.62-2,.18-2-1A4.22,4.22,0,0,1,255.79,219.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumefolderAmico);
export default __webpack_public_path__ + "static/media/Resume folder-amico.bf0ce501139105bd6dd6b7d230c8290b.svg";
export { ForwardRef as ReactComponent };